import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BackendService } from '../../../../core/backend.service';
import { CostoEnvioMasivo } from '../../../../pedido/costo-envio/costo-envio-masivo.model';
import { SnackService } from '../../../../shared-services/snack.service';


@Component({
  selector: 'app-modal-modificacion-costos-envio-masivo',
  templateUrl: './modal-modificacion-costos-envio-masivo.component.html',
  styleUrls: ['./modal-modificacion-costos-envio-masivo.component.scss']
})
export class ModalModificacionCostosEnvioMasivoComponent{

    public title: string;
    public firstMessage: string;
    public opcionesModificacion: string[] = ["Aumento","Descuento"];
    opcionModElegida:string = "Aumento";
  @ViewChild('form') public roleForm: NgForm;
  toppings = new FormControl();
  @ViewChild('fruitInput') fruitInput: ElementRef;

    okButtonTextLabel = 'Aceptar';
    cancelButtonTextLabel = 'Cancelar';
    updatePrecios: CostoEnvioMasivo = new CostoEnvioMasivo();
  

    constructor(public dialogRef: MatDialogRef<ModalModificacionCostosEnvioMasivoComponent>,
      private backendService:BackendService,
      private snackService:SnackService) {}

    public set okButtonText(value: string)  {
      this.okButtonTextLabel = value;
    }

    public set cancelButtonText(value: string) {
      this.cancelButtonTextLabel = value;
    }

    compareFn(c1: any, c2: any): boolean {
      return c1 && c2 ? c1.id === c2.id : c1 === c2;
    }

    async save() {

        this.snackService.spinner(true);
        
         // Update
         console.log(this.opcionModElegida);
         if(this.opcionModElegida == "Descuento"){
          this.updatePrecios.aumentoPrecio = this.updatePrecios.aumentoPrecio *-1
          }
          try {
            
             await this.backendService.create(CostoEnvioMasivo.path, this.updatePrecios);
            this.snackService.success('Precio Agregado');
            //this.router.navigate(['/modificaciones-precio']);
          } catch (ex) {
            this.snackService.error(ex.message);
          } finally {
            this.snackService.spinner(false);
            this.dialogRef.close(true);
          }
        
      }


}



// WEBPACK FOOTER //
// ./src/app/shared-components/modals/modificacion-costos-envio/modal-modificacion-costos-envio-masivo/modal-modificacion-costos-envio-masivo.component.ts